import axios from 'axios';

export default {
  baseURL: process.env.BASE_URL + 'api/download',

  getDownloadMetaInformation(downloadToken, cancelToken) {
    return axios.get('',
      { 
        baseURL: this.baseURL + '/meta/' + downloadToken,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        
        return Promise.reject(error);
      });
  },

  getDownloadFile(downloadToken, options, cancelToken) {
    return axios.get('',
      { 
        baseURL: this.baseURL + '/' + downloadToken,
        responseType: 'blob',
        params: {
          'localization-id': (options && options.localizationId) ? options.localizationId : null,
          'target-group': (options && options.targetGroup) ? options.targetGroup : null,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        
        return Promise.reject(error);
      });
  }
};